import React, { useRef } from "react";
import TYPE from "../../../constant/TYPE";
import { getMathJaxNode } from "../mathjax/MathJax";

const MultiplicationAndDivision = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.MULTIPLICATION_AND_DIVISION }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.MULTIPLICATION_AND_DIVISION }}`;
  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '&' ).map( v => v.trim() );
  const changedDataCount = data.filter( ( v, i ) => prevData.current[ i ] !== v ).length;

  const MathJaxNode = getMathJaxNode( props.type );

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  return (
    <table className="tbl-htreeD">
      <tbody>
      <tr>
        <td rowSpan="2"><span className="inputTxtN"><MathJaxNode onRender={ renderMathJax }>{ data[ 0 ] }</MathJaxNode></span></td>
        <td className="d-up pl-1"><span className="diagonal"><span className="line" /></span></td>
        <td className="pb-1"><span className="inputTxtN"><MathJaxNode onRender={ renderMathJax }>{ data[ 1 ] }</MathJaxNode></span></td>
      </tr>
      <tr>
        <td className="d-down pl-1"><span className="diagonal"><span className="line" /></span></td>
        <td className="pt-1"><span className="inputTxtN"><MathJaxNode onRender={ renderMathJax }>{ data[ 2 ] }</MathJaxNode></span></td>
      </tr>
      </tbody>
    </table>
  );

};

export default MultiplicationAndDivision;
